import { memo } from 'react'
import { ReservationSeat } from '@/types/codegen-federation'

export const SEAT_WIDTH = 40
export const HORIZONTAL_SEAT_SPACING = 10
export const VERTICAL_SEAT_SPACING = 25

interface SeatImageProps {
  seat: ReservationSeat
  onSeatPressed: (seat: ReservationSeat) => void
  selected: boolean
  isViewOnly?: boolean
}

export const Seat = ({ seat, onSeatPressed, selected, isViewOnly }: SeatImageProps) => {
  const id = seat?.seatType.reference
  const horizontalSpace = 0
  const verticalSpace = 10
  const seatHeight = 50

  if (!id) return null
  const xAxis = seat.xCoord * (SEAT_WIDTH + horizontalSpace)
  const yAxis = seat.yCoord * (seatHeight + verticalSpace)

  const cloudinaryPath = seat.seatType.icons.default.cloudinaryPath
  const selectedCloudinaryPath = seat.seatType.icons.selected.cloudinaryPath

  return (
    <g key={seat.seatId} transform={`translate(${xAxis}, ${yAxis})`}>
      <image
        width={40}
        height={50}
        className={isViewOnly ? 'cursor-default' : 'cursor-pointer'}
        onClick={() => !isViewOnly && onSeatPressed(seat)}
        xlinkHref={`https://images.angelstudios.com/image/upload/${
          selected ? selectedCloudinaryPath : cloudinaryPath
        }.svg`}
      />
    </g>
  )
}

export default memo(Seat)
